export async function parseStream(
  stream: ReadableStream<Uint8Array> | undefined,
  onUpdate: (v: string) => void,
) {
  if (!stream) {
    return;
  }

  let reader: ReadableStreamDefaultReader<Uint8Array>;
  try {
    reader = stream.getReader();
  } catch (error) {
    console.error('Failed to get reader:', error);
    return;
  }

  const decoder = new TextDecoder();
  const message: string[] = [];

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value);
      const parsedChunk = parseSSEChunk(chunk);
      message.push(parsedChunk);
      onUpdate(message.join(''));
    }
  } catch (error) {
    console.error('Error reading stream:', error);
  } finally {
    reader.releaseLock();
  }
}

export function parseSSEChunk(chunk: string): string {
  return chunk
    .split(/\r\n|\n/) // split on '\r\n' or '\n'
    .filter((line) => line.startsWith('data:')) // keep data lines, including empty ones
    .map((line) => line.replace(/^data:\s?/, '')) // remove prefix (including optional space)
    .filter((content) => content !== '[DONE]') // skip SSE end marker
    .map((line) => (line === '' ? '\n' : line)) // interpret empty data lines as newlines
    .join('');
}

export function getInputCommand(message: string) {
  return ['/dev', '/explain', '/reset'].find((command) =>
    message.startsWith(command),
  );
}
